import React from 'react';
import { useAddExerciseLoadFormulaComponent } from './useAddExerciseLoadFormulaComponent';
import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';
import AppFormTextField from '../../../../components/designe/app-form-text-field';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddExerciseLoadFormula.styles';
import theme from '../../../../styles/theme';
import { IExerciseLoadFormula } from '../../../../types/interfaces/exercise-load-formula';

interface IAddExerciseLoadFormulaProps {
  exerciseLoadFormula: IExerciseLoadFormula;
  onClose: () => void;
}

export default function AddExerciseLoadFormula(
  props: IAddExerciseLoadFormulaProps,
) {
  const { exerciseLoadFormula, onClose } = props;
  const { t } = useTranslation();
  const { formik, isLoading } = useAddExerciseLoadFormulaComponent(
    onClose,
    exerciseLoadFormula,
  );
  const { classes } = useStyles(theme);

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.nameKey')}
              fullWidth
              name="nameKey"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.value')}
              fullWidth
              name="value"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.priority')}
              fullWidth
              type="number"
              name="priority"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="active"
                  checked={formik.values.active}
                  onChange={(e) =>
                    formik.setFieldValue('active', e.target.checked)
                  }></Checkbox>
              }
              label={t('common.active')}
            />
          </Grid>
        </Grid>
        <Box className={classes.addExerciseLoadFormulaButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {exerciseLoadFormula ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
